<template>
  <div>
    <template v-for="button in buttons">
      <v-tooltip v-if="getVisibilityButton(button, row, rowIndex, rows)" :key="button.id" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="onClick(button)"
            elevation="0"
            class="mr-2"
            :fab="button.dark"
            :small="button.dark"
            :icon="!button.dark"
            :color="button.color"
            :dark="button.dark"
            v-on="on"
          >
            <v-icon>{{button.icon}}</v-icon>
          </v-btn>
        </template>
        <span>{{button.tooltip}}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { getVisibilityButton } from './getVisibilityButton'

export default {
  name: 'ButtonCellContent',
  props: ['buttons', 'rowIndex', 'row', 'rows'],
  methods: {
    onClick(button) {
      this.$emit('buttonClicked', button)
    },
    getVisibilityButton
  }
}
</script>

